import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import rarities from '../../data/rarities'
import Tooltip from '../general/Tooltip'
import { desktop } from '../../styles/media'
import translate from '../../helper/translate'
import { capitalize } from '../../helper/string'

const RarityBar = ({ rarityId, t }) => {
	const rarityColor = rarityId ? rarities[rarityId].background : 'unknown'
	const rarityBorderColor = rarityId ? rarities[rarityId].borderColor : null
	const title= rarityId ? rarities[rarityId].name : null

	return (
		<Tooltip title={title || capitalize(t('general.unknown'))}>
			<StyledRarityBar
				rarityColor={rarityColor}
				rarityBorderColor={rarityBorderColor}
			/>
		</Tooltip>
	)
}

RarityBar.propTypes = {
	rarityId: PropTypes.number,
	t: PropTypes.func.isRequired
}

RarityBar.defaultProps = {
	rarityId: null
}

const StyledRarityBar = styled.div`
	background: ${props => props.rarityColor !== 'unknown' ? props.theme[props.rarityColor] : props.theme.backgroundLight};
	height: 30px;
	width: 5px;
	transition: 0.1s;

	position: relative;

	&:after {
		content: "";
		position: absolute;
		height: 30px;
		width: 20px;

		left: 50%;
		transform: translate(-50%);
	}

	${props => props.rarityColor === 'unknown' ? `
		&:before {
			content: "?";
			position: absolute;
			left: -4px;
			top: 50%;
			transform: translate(0, -50%);

			align-items: center;
			display: flex;
			justify-content: center;

			background: ${props.theme.id === 'dark' ? props.theme.backgroundDark : props.theme.textVeryLight};
			border-radius: 50%;
			color: ${props.theme.white};
			font-size: 0.6rem;
			font-weight: 800;
			height: 13px;
			width: 13px;
			z-index: 1;
		}
	` : ''}

	${props => props.rarityBorderColor && `
		&:before {
			box-shadow: 0 0 0 1px ${props.theme[props.rarityBorderColor]};
			border-radius: 1px;
			height: 30px;
			width: 5px;

			content: "";
			position: absolute;
			left: 0;
			top: 50%;
			transform: translate(0, -50%);
		}
	`}

	${desktop`
		&:hover {
			box-shadow: 0 0 0 1px ${props => props.theme.background}, 0 0 0 3px ${props => props.theme.backgroundLight};
			border-radius: 2px;
		}
	`}
`

const enhance = translate('general')

export default enhance(RarityBar)
